import React, { useState, useContext } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { Context } from "../../config/AuthContext";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountBoxIcon from "@mui/icons-material/AccountBox";

import LockIcon from "@mui/icons-material/Lock";

import styles from "./styles.module.css";

import logoBrancoAltura from "../../images/logoBrancoAltura.png";
import CircleLoader from "react-spinners/CircleLoader";

import {
  authenticationHandler,
  enviarTokenSenhaHandler,
} from "../../services/auth.service";

import LockOpenIcon from "@mui/icons-material/LockOpen";

import MailOutlineIcon from "@mui/icons-material/MailOutline";

import { Dialog, DialogTitle, DialogContent, Grid } from "@mui/material";

import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";

export const Login = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpenModal = (rowData) => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const { from = "/dashboard" } = state || {};

  const { signIn } = useContext(Context);

  const [user, setUser] = useState({
    login: "",
    senha: "",
  });

  const [status, setStatus] = useState({
    type: "",
    mensagem: "",
    loading: false,
  });

  const [msg, setMsg] = useState("");

  const valorInput = (e) =>
    setUser({ ...user, [e.target.name]: e.target.value });

  const loginSubmit = async (e) => {
    e.preventDefault();
    setStatus({
      loading: true,
    });

    authenticationHandler({
      login: user.login,
      senha: user.senha,
      sistema: "PTAX",
    })
      .then((response) => {
        signIn(response.objRetorno);
        return
      })
      .catch((err) => {
        if (err.response) {
          setStatus({
            type: "error",
            mensagem: err.response.data.mensagem,
            loading: false,
          });
        } else {
          setStatus({
            type: "error",
            mensagem: "Erro: tente mais tarde!",
            loading: false,
          });
        }
      });
  };

  const [email, setEmail] = useState("");

  const enviarTokenSenha = async (e) => {
    setLoading(true);
    enviarTokenSenhaHandler({ email })
      .then((response) => {
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
        handleCloseModal();
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response);
          handleOpenSnackbarErro();
        } else {
          setMsg("Por favor, tente novamente mais tarde.");
          handleOpenSnackbarErro();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  return (
    <div>
      <Card className={styles.cardLogin}>
        <CardContent>
          <div className={styles.divHeaderLogin}>
            <img
              className={styles.imgAltura}
              src={logoBrancoAltura}
              alt="Logo"
            />
          </div>
          <form onSubmit={loginSubmit}>
            <TextField
              className={styles.loginTextField}
              fullWidth
              size="small"
              variant="outlined"
              onChange={valorInput}
              name="login"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <div className={styles.fundoUsuario}>
                      <AccountBoxIcon className={styles.iconeUsuario} />
                    </div>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              className={styles.senhaTextField}
              fullWidth
              size="small"
              variant="outlined"
              type="password"
              onChange={valorInput}
              name="senha"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <div className={styles.fundoUsuario}>
                      <LockIcon className={styles.iconeUsuario} />
                    </div>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              className={styles.botaoAcessar}
              variant="contained"
            >
              Acessar
            </Button>
            <Button
              className={styles.botaoEsqueciSenha}
              variant="contained"
              onClick={handleOpenModal}
            >
              Esqueci minha senha
            </Button>
          </form>

          {status.type === "error" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.type === "success" ? (
            <p className={styles.mensagemUsuario}>{status.mensagem}</p>
          ) : (
            ""
          )}
          {status.loading ? (
            <p className={styles.mensagemUsuario}>Carregando...</p>
          ) : (
            ""
          )}
        </CardContent>
        <CardActions></CardActions>
      </Card>

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "500px", // Defina a largura desejada
          },
        }}
        maxWidth="md" // Defina o tamanho máximo do modal
      >
        {loading ? (
          <div className={styles.loading}>
            <CircleLoader
              color="#18316e"
              loading={loading}
              size={100}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        ) : (
          <>
            <DialogTitle>
              <div className={styles.tituloPopupContainer}>
                <LockOpenIcon fontSize="30px" />
                <h1 className={styles.tituloPopup}>Redefinir senha</h1>
              </div>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    type="email"
                    placeholder="Digite o seu e-mail..."
                    name="login"
                    onChange={handleChangeEmail}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div className={styles.fundoUsuario}>
                            <MailOutlineIcon className={styles.iconeUsuario} />
                          </div>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    className={styles.botaoPopupCancelar}
                    onClick={handleCloseModal}
                    size="small"
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    fullWidth
                    className={styles.botaoPopupSalvar}
                    onClick={enviarTokenSenha}
                    color="primary"
                    size="small"
                  >
                    Enviar
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </>
        )}
      </Dialog>
      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
